
// src/components/Navbar/NavbarLarge.jsx
import React, { useState, useEffect, useRef } from 'react';
import {
  NavContainer,
  LogoImage,
  NavTabs,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownButton,
  LanguageDropdownMenu,
  DropdownLanguageItem,
  LogOutDiv,
  MenuFlexBox
} from './Navbar.styles';
// import Logo from '../../assets/logos/gr-logo.jpg';
import logoEn from '../../assets/logos/en-logo.png';
import logoGr from '../../assets/logos/gr-logo.jpg';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DownArrow } from '../../assets/svgs/down-arrow-dark.svg';
import { ReactComponent as RightArrow } from '../../assets/svgs/right-arrow-option.svg';
import { ReactComponent as LanguagesSVG } from '../../assets/svgs/languages.svg';
import { ReactComponent as ProfileSVG } from '../../assets/svgs/profile-icon.svg';
import { ReactComponent as LogOutSVG } from '../../assets/svgs/logout.svg';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';

const NavbarLarge = ({ setAccessibilityOpen }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL || '/';
  const [userRole, setUserRole] = useState('');
  const [signedIn, setSignedIn] = useState(Boolean(sessionStorage.getItem('loggedIn')));
  const [userName, setUserName] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [providerProfileOpen, setProviderProfileOpen] = useState(false);
  const [visitorProfileOpen, setVisitorProfileOpen] = useState(false);
  const [isDestinationsOpen, setDestinationsOpen] = useState(false);
  const [isExperiencesOpen, setExperiencesOpen] = useState(false);
  const [isAmenitiesOpen, setAmenitiesOpen] = useState(false);

  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'gr', label: 'GR' },
  ];
  const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  // refs for clickOutside
  const dropdownRef = useRef(null);
  const providerProfileButtonRef = useRef(null);
  const visitorProfileButtonRef = useRef(null);
  const destinationsButtonRef = useRef(null);
  const experiencesButtonRef = useRef(null);
  const amenitiesButtonRef = useRef(null);
  const destinationsMenuRef = useRef(null);
const amenitiesMenuRef = useRef(null);
const experiencesMenuRef = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const [destinationCategories, setDestinationCategories] = useState([]);
  const [experienceCategories, setExperienceCategories] = useState([]);
  const [amenityCategories, setAmenityCategories] = useState([]);
  

  useEffect(() => {
    const fetchCategories = async (endpoint, setter) => {
      try {
        const response = await fetch(`${BASE_URL}${endpoint}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setter(data);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
      }
    };

    fetchCategories("DestinationCategory", setDestinationCategories);
    fetchCategories("ExperienceCategory", setExperienceCategories);
    fetchCategories("AmenityCategory", setAmenityCategories);
  }, [BASE_URL]);

  useEffect(() => {
    setSignedIn(Boolean(sessionStorage.getItem('loggedIn')));
    const tokenString = sessionStorage.getItem('token');
    if (tokenString) {
      try {
        const decodedToken = jwtDecode(decodeURIComponent(tokenString));
        const role = decodedToken.prn || decodedToken.role || '';
        setUserRole(role);
        sessionStorage.setItem('userRole', role);
        setUserName(decodedToken.sub || '');
      } catch (err) {
        console.error('Error decoding token', err);
      }
    }
  }, [signedIn]);

  const logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('userRole');
    toast.success('Logout Successful!');
    navigate('/register-signIn');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    window.location.reload();
  };

useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      destinationsButtonRef.current && destinationsMenuRef.current &&
      !destinationsButtonRef.current.contains(e.target) &&
      !destinationsMenuRef.current.contains(e.target)
    ) setDestinationsOpen(false);

    if (
      amenitiesButtonRef.current && amenitiesMenuRef.current &&
      !amenitiesButtonRef.current.contains(e.target) &&
      !amenitiesMenuRef.current.contains(e.target)
    ) setAmenitiesOpen(false);

    if (
      experiencesButtonRef.current && experiencesMenuRef.current &&
      !experiencesButtonRef.current.contains(e.target) &&
      !experiencesMenuRef.current.contains(e.target)
    ) setExperiencesOpen(false);

    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false);
    if (providerProfileButtonRef.current && !providerProfileButtonRef.current.contains(e.target)) setProviderProfileOpen(false);
    if (visitorProfileButtonRef.current && !visitorProfileButtonRef.current.contains(e.target)) setVisitorProfileOpen(false);
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);


  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    sessionStorage.setItem('selectedLanguage', langCode);
    setDropdownOpen(false);
    window.location.reload();
  };

  const arrowFill = (isOpen, isActive) => (isOpen || isActive ? '#91abb3' : '#385963');

  const Logo = i18n.language === 'en' ? logoEn : logoGr;

  return (
    <NavContainer role="navigation" aria-label="Main navigation" data-aos="fade-down">
      <Link to="/">
        <LogoImage src={Logo} alt="Logo" />
      </Link>

      <MenuFlexBox>
        <NavTabs>


          {/* About Pieria */}
          <li className="nav-tab">
            <Link
              to="/about-pieria"
              style={{ color: location.pathname === '/about-pieria' ? '#91abb3' : '#385963' }}
            >
              {i18n.t('aboutPieria')}
            </Link>
          </li>

          <li>
            <Dropdown>
              <DropdownButton
                ref={destinationsButtonRef}
                onClick={() => setDestinationsOpen(prev => !prev)}
              >
                {i18n.t('destinations')}
                <DownArrow
                  style={{
                    transform: isDestinationsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                  }}
                />
              </DropdownButton>
          
              {isDestinationsOpen && (
                <DropdownMenu ref={destinationsMenuRef}>
                  {destinationCategories.map((cat) => (
                    <DropdownItem
                      key={cat.id}
                      onClick={() => {
                        navigate('/destinations', { state: { activeComponent: 'mainDestinations', categoryId: cat.id } });
                        setDestinationsOpen(false);
                      }}
                    >
                      <RightArrow height={10} width={30} />
                      {cat.name[selectedLanguage]}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              )}
            </Dropdown>
          </li>

          <li>
             <Dropdown>
               <DropdownButton
                 ref={experiencesButtonRef}
                 onClick={() => setExperiencesOpen(prev => !prev)}
               >
                 {i18n.t('experiences')}
                 <DownArrow
                   style={{
                     transform: isExperiencesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                     transition: 'transform 0.3s',
                   }}
                 />
               </DropdownButton>
           
               {isExperiencesOpen && (
                 <DropdownMenu ref={experiencesMenuRef}>
                   {experienceCategories.map((cat) => (
                     <DropdownItem
                       key={cat.id}
                       onClick={() => {
                         navigate('/experiences', { state: { activeComponent: 'mainExperiences', categoryId: cat.id } });
                         setExperiencesOpen(false);
                       }}
                     >
                       <RightArrow height={10} width={30} />
                       {cat.name[selectedLanguage]}
                     </DropdownItem>
                   ))}
                 </DropdownMenu>
               )}
             </Dropdown>
          </li>
          

          <li>
             <Dropdown>
               <DropdownButton
                 ref={amenitiesButtonRef}
                 onClick={() => setAmenitiesOpen(prev => !prev)}
               >
                 {i18n.t('amenities')}
                 <DownArrow
                   style={{
                     transform: isAmenitiesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                     transition: 'transform 0.3s',
                   }}
                 />
               </DropdownButton>
           
               {isAmenitiesOpen && (
                 <DropdownMenu ref={amenitiesMenuRef}>
                   {amenityCategories.map((cat) => (
                     <DropdownItem
                       key={cat.id}
                       onClick={() => {
                         navigate('/amenities', { state: { activeComponent: 'mainAmenities', categoryId: cat.id } ,replace: true});
                         setAmenitiesOpen(false);
                       }}
                     >
                       <RightArrow height={10} width={30} />
                       {cat.name[selectedLanguage]}
                     </DropdownItem>
                   ))}
                 </DropdownMenu>
               )}
             </Dropdown>
          </li>
          

          {/* Plan your trip */}
          <li>
            <Link to="/plan-your-trip" style={{ color: location.pathname === '/plan-your-trip' ? '#91abb3' : '#385963' }}>
              {i18n.t('planYourTrip')}
            </Link>
          </li>

          {/* Event Calendar */}
          <li>
            <Link to="/event-calendar" style={{ color: location.pathname === '/event-calendar' ? '#91abb3' : '#385963' }}>
              {i18n.t('calendar')}
            </Link>
          </li>

          {/* Accessibility Points */}
          <li className="nav-tab">
            <a
              // href="https://www.olympus-riviera.gr/embed/map"
              // target="_blank"
              // rel="noopener noreferrer"
            href="#!"
            onClick={() => {
              setAccessibilityOpen(true);
            }}
            >
              {i18n.t('accessibilityPoints')}
            </a>
          </li>

           {/* Register / Sign In */}
           {!signedIn && (
             <li>
               <Link
                 to="/register-signIn"
                 style={{ color: location.pathname === '/register-signIn' ? '#91abb3' : '#385963' }}
               >
                 {i18n.t('registerSignIn')}
               </Link>
             </li>
           )}
           {/* User Profile / Provider */}
           {signedIn && (userRole === 'Provider' || userRole === 'PreApprovedProvider') && (
             <li>
               <Dropdown>
                 <DropdownButton
                   ref={providerProfileButtonRef}
                   onClick={() => setProviderProfileOpen(!providerProfileOpen)}
                 >
                   <ProfileSVG height={18} width={20} />
                 </DropdownButton>
                 {providerProfileOpen && (
                   <DropdownMenu ref={providerProfileButtonRef}>
                     {userRole === 'Provider' && (
                       <>
                         <DropdownItem onClick={() => navigate('/profile-menu-provider', { state: { activeComponent: 'crudProfile' } })}>
                           <RightArrow height={10} width={30} /> {i18n.t('manageProfile')}
                         </DropdownItem>
                         <DropdownItem onClick={() => navigate('/profile-menu-provider', { state: { activeComponent: 'businesses' } })}>
                           <RightArrow height={10} width={30} /> {i18n.t('businesses')}
                         </DropdownItem>
                         <DropdownItem onClick={() => navigate('/profile-menu-provider', { state: { activeComponent: 'crudProviderEventRequest' } })}>
                           <RightArrow height={10} width={30} /> {i18n.t('events')}
                         </DropdownItem>
                       </>
                     )}
                     {userRole === 'PreApprovedProvider' && (
                       <DropdownItem onClick={() => navigate('/profile-menu-pre-approved-provider')}>
                         <RightArrow height={10} width={30} /> {i18n.t('manageProfile')}
                       </DropdownItem>
                     )}
                     <DropdownItem onClick={handleLogout}>
                       <LogOutDiv>
                         <LogOutSVG height={27} width={27} /> <p>{i18n.t('signOut')}</p>
                       </LogOutDiv>
                     </DropdownItem>
                   </DropdownMenu>
                 )}
               </Dropdown>
             </li>
           )}

           {/* Visitor Profile */}
          {signedIn && userRole === 'RegisteredUser' && (
            <li>
              <Dropdown>
                <DropdownButton
                  ref={visitorProfileButtonRef}
                  onClick={() => setVisitorProfileOpen(!visitorProfileOpen)}
                >
                  {/* {userName}  */}
                  <ProfileSVG height={18} width={20} />
                </DropdownButton>
                {visitorProfileOpen && (
                  <DropdownMenu ref={visitorProfileButtonRef}>
                    <DropdownItem onClick={() => navigate('/profile-menu-visitor', { state: { activeComponent: 'crudProfileVisitor' } })}>
                      <RightArrow height={10} width={30} /> {i18n.t('manageProfile')}
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate('/profile-menu-visitor', { state: { activeComponent: 'preferences' } })}>
                      <RightArrow height={10} width={30} /> {i18n.t('preferences')}
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate('/profile-menu-visitor', { state: { activeComponent: 'pointsVisited' } })}>
                      <RightArrow height={10} width={30} /> {i18n.t('pointsOfInterest')}
                    </DropdownItem>
                    <DropdownItem onClick={handleLogout}>
                      <LogOutDiv>
                        <LogOutSVG height={27} width={27} /> <p>{i18n.t('signOut')}</p>
                      </LogOutDiv>
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </Dropdown>
            </li>
          )}

          {/* Language */}
          <li>
            <Dropdown>
              <DropdownButton ref={dropdownRef} onClick={() => setDropdownOpen(!dropdownOpen)}>
                {currentLanguage ? currentLanguage.label : 'EN'}
                <LanguagesSVG height={18} width={18} />
              </DropdownButton>

              {dropdownOpen && (
                <LanguageDropdownMenu ref={dropdownRef}>
                  {languages.map((lang) => (
                    <DropdownLanguageItem key={lang.code} onClick={() => changeLanguage(lang.code)}>
                      {lang.label}
                    </DropdownLanguageItem>
                  ))}
                </LanguageDropdownMenu>
              )}
            </Dropdown>
          </li>
        </NavTabs>
      </MenuFlexBox>
    </NavContainer>
  );
};

export default NavbarLarge;


